define(() => {
    "use strict";

    const baseUrl = process.env.APP_CONFIG.editorBaseUrl;

    const WIDGET_TYPE_ICONS = [
        {"id": "big-commerce", "icon": "big-commerce-widget-icon.svg"},
        {"id": "box", "icon": "box-widget-icon.svg"},
        {"id": "button", "icon": "button-widget-icon.svg"},
        {"id": "demandware", "icon": "commerce-cloud-widget-icon.svg"},
        {"id": "dynamic-product", "icon": "dynamic-product-widget-icon.svg"},
        {"id": "embed", "icon": "embed-widget-icon.svg"},
        {"id": "generic-product", "icon": "generic-product-widget-icon.svg"},
        {"id": "hybris", "icon": "hybris-widget-icon.svg"},
        {"id": "html", "icon": "html-widget-icon.svg"},
        {"id": "image", "icon": "image-widget-icon.svg"},
        {"id": "line", "icon": "line-widget-icon.svg"},
        {"id": "link", "icon": "link-widget-icon.svg"},
        {"id": "magento", "icon": "magento-widget-icon.svg"},
        {"id": "next-scene", "icon": "next-scene-widget-icon.svg"},
        {"id": "oracle", "icon": "oracle-widget-icon.svg"},
        {"id": "previous-scene", "icon": "previous-scene-widget-icon.svg"},
        {"id": "scene-slider", "icon": "scene-slider-widget-icon.svg"},
        {"id": "shopify", "icon": "shopify-widget-icon.svg"},
        {"id": "social", "icon": "social-widget-icon.svg"},
        {"id": "text", "icon": "text-widget-icon.svg"},
        {"id": "text-enhanced", "icon": "text-widget-icon.svg"},
        {"id": "websphere", "icon": "websphere-widget-icon.svg"},
        {"id": "youtube", "icon": "youtube-widget-icon.svg"}
    ].reduce((accum, wType) => {
        accum[wType.id] = `${baseUrl}/images/widget-icons/${wType.icon}`;
        return accum;
    }, {});

    return {
        WIDGET_TYPE_ICONS
    };
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/WidgetHelpers.js